import React from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, TableContainer } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";
import { Edit } from "lucide-react";

export function CardDadosVenda({ venda }) {
	if (!venda) return null;

	const handleOpenModal = () => {
		const event = new CustomEvent("modalSelectClientVenda");
		window.dispatchEvent(event);
	};

	const cidadeStr = venda.cidade ? `${venda.cidade}${venda.uf ? ` / ${venda.uf}` : ""}` : "—";

	return (
		<div className="">
			{/* DADOS DA VENDA */}
			<div className="mb-6">
				<h2 className="text-lg font-bold text-[#1e3a8a] mb-2 border-b-2 border-[#1e3a8a] pb-1 uppercase tracking-wide">
					Dados da Venda
				</h2>
				<div className="grid grid-cols-2 gap-4">
					<div>
						<p className="text-xs text-gray-500 uppercase mb-1">Código da Venda</p>
						<p className="font-bold text-gray-800">
							{venda.id_venda || "—"}
							{venda.correlationid && (
								<span className="ml-2 text-xs font-normal text-gray-400">
									(correlation_id: {venda.correlationid})
								</span>
							)}
						</p>
					</div>
					<div>
						<p className="text-xs text-gray-500 uppercase mb-1">Data da Venda</p>
						<p className="font-bold text-gray-800">
							{venda.datavenda
								? formatInTimeZone(new Date(venda.datavenda), "UTC", "dd/MM/yyyy HH:mm")
								: "—"}
						</p>
					</div>
				</div>
			</div>

			{/* DADOS DO CLIENTE */}
			<div className="mb-8">
				<div className="flex justify-end items-end mb-2 border-b-2 border-[#1e3a8a] pb-1">
					<button
						className="flex items-center gap-1 text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors uppercase"
						title="Editar Cliente"
						onClick={handleOpenModal}
					>
						<Edit size={14} /> Alterar Cliente
					</button>
				</div>
				<TableContainer component={Paper} className="shadow-none border border-gray-200 rounded-none">
					<Table size="small">
						<TableHead className="color-table">
							<TableRow>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Nome</TableCell>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>CPF / CNPJ</TableCell>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Telefone</TableCell>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>E-mail</TableCell>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Cidade / UF</TableCell>
								<TableCell style={{ color: "#fff", fontWeight: "bold" }}>Vendedor</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow hover>
								<TableCell>{venda.nome || "Consumidor Final"}</TableCell>
								<TableCell>{venda.cpf || venda.cnpj || "—"}</TableCell>
								<TableCell>{venda.telefone_1 || venda.telefone_2 || "—"}</TableCell>
								<TableCell>{venda.email || "—"}</TableCell>
								<TableCell>{cidadeStr}</TableCell>
								<TableCell>{venda.nome_funcionario || "—"}</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</div>
	);
}
